import { SiteLocale } from '@graphql/generated';
import 'dotenv/config';
import _ from 'lodash';
import { NextConfig } from 'next';
import config from './data/config.json' with { type: 'json' };
import data from './data/markets.json' with { type: 'json' };

function getPaths() {
  const langs = config.availableLocales.locales.filter((l) => l !== 'en') as SiteLocale[];
  const markets = data.map(({ market_name }) => {
    const [market, currency] = market_name.split(' ').map((item) => item.toLowerCase());
    return { market, currency };
  });

  const paths = langs.flatMap((lang) =>
    _.orderBy(
      _.uniqBy(markets, 'market').map(({ market, currency }) => ({
        market,
        currency,
        lang: lang,
      })),
      ['currency', 'market', 'lang']
    )
  );

  return paths;
}

export const subPaths = {
  categories: {
    en: 'categories',
    it: 'categorie',
    de: 'kategorien',
    fr: 'categories',
    es: 'categorias',
  },
  products: {
    en: 'products',
    it: 'prodotti',
    de: 'produkte',
    fr: 'produits',
    es: 'productos',
  },
};

function getRedirectList() {
  const paths = getPaths();

  const list = paths.flatMap(({ currency, market, lang }) => {
    const baseUrl = `/${market}/${currency}/${lang}`;
    return [
      {
        source: `${baseUrl}/${subPaths.categories[lang]}/:category*`,
        destination: `${baseUrl}/categories/:category*`,
      },
      {
        source: `${baseUrl}/${subPaths.products[lang]}/:product`,
        destination: `${baseUrl}/products/:product`,
      },
    ];
  });

  return list;
}

const rewritesList = getRedirectList();

const nextConfig: NextConfig = {
  images: {
    remotePatterns: [
      {
        protocol: 'https',
        hostname: 'www.datocms-assets.com',
        pathname: '**',
      },
    ],
  },
  reactStrictMode: true,
  poweredByHeader: false,
  env: {
    PROJECT_NAME: process.env.PROJECT_NAME || '',
    CL_ENDPOINT: process.env.CL_ENDPOINT || '',
    CL_CLIENT_ID: process.env.CL_CLIENT_ID || '',
    DATO_ENV: process.env.DATO_ENV || '',
    DATO_API_TOKEN: process.env.DATO_API_TOKEN || '',
    HOST: process.env.HOST || '',
    NEXT_PUBLIC_B2B_ENABLE: process.env.NEXT_PUBLIC_B2B_ENABLE || 'false',
    NEXT_PUBLIC_B2B_ORG: process.env.NEXT_PUBLIC_B2B_ORG || '',
    ELASTIC_HOST: process.env.ELASTIC_HOST || '',
    ELASTIC_ACCESS_KEY: process.env.ELASTIC_ACCESS_KEY || '',
    ELASTIC_SECRET_KEY: process.env.ELASTIC_SECRET_KEY || '',
    DRAFT_ENV: process.env.DRAFT_ENV || '',
    DD_APPLICATION_ID: process.env.DD_APPLICATION_ID || '',
    DD_CLIENT_TOKEN: process.env.DD_CLIENT_TOKEN || '',
    MFE_MY_ACCOUNT_URL: process.env.MFE_MY_ACCOUNT_URL || '',
  },
  async rewrites() {
    return [...rewritesList];
  },
  // async redirects() {
  //   return [...rewritesList];
  // },
  generateBuildId: () => 'build',
  productionBrowserSourceMaps: true,
  async headers() {
    return [
      {
        source: '/:path*',
        headers: [
          {
            /**
             * Any content changes are confirmed with a build or purge of the netlify cache, we can then cache the pages.
             *
             * https://docs.netlify.com/platform/caching/
             * https://docs.netlify.com/platform/caching/#supported-cache-control-headers
             * https://docs.netlify.com/platform/caching/#default-values
             */
            key: 'Netlify-CDN-Cache-Control',
            /**
             * s-maxage=31536000: CDN or proxy servers (like Netlify) can cache the content for 1 year.
             * stale-while-revalidate:
             *    When the period specified by s-maxage ends:
             *      The cache becomes stale (obsolete)
             *      The CDN or browser can continue to serve the stale response to clients
             *      Meanwhile, the CDN contacts the backend (e.g., Next.js or Netlify Functions) to update the content and reload the cache.
             */
            value: 'public, s-maxage=31536000, stale-while-revalidate',
          },
        ],
      },
    ];
  },
};

export default nextConfig;
